import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "admin-panel" }
const _hoisted_2 = { class: "admin-panel__left-group" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "q-pa-md" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "dialog-title" }, "Назначить тесты", -1)
const _hoisted_6 = ["disabled"]

import { computed, onMounted, ref } from "vue";
import AdminApi from "@/api/AdminApi";

import { useMainStore } from "@/store";

import UsersTableTab from "./adminTabs/UsersTableTabComponent.vue";
import TestsetsTab from "./adminTabs/TestsetsTabComponent.vue";
import StatisticsTab from "./adminTabs/StatisticsTabComponent.vue";
import ITest from "@/interfaces/ITest";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminComponent',
  setup(__props) {

const api = new AdminApi();

const mainStore = useMainStore();

const usersTableTabComponent = ref();
const testsetsTabComponent = ref();
const statisticsTabComponent = ref();

const currentTab = computed(() => {
  return mainStore.lastVisitedTabs;
});

const testDialog = ref(false);
const selectedTests = ref([]);
const tests = ref([] as { label: string; value: number }[]);
let isSelectedUsers = computed(() => {
  if (usersTableTabComponent.value) {
    return usersTableTabComponent.value.selected.length === 0;
  }
  return true;
});

function openAssignTestPopup(): void {
  testDialog.value = true;
}

/*Assigns a test for a user.*/
async function assignTestForUser() {
  const userAzureIds = usersTableTabComponent.value.selected.map((user: any) => user.azureId);
  await api.assignTest(selectedTests.value, userAzureIds);
  testDialog.value = false;
}

/* Retrieves tests from the API and adds them to the tests array.*/
async function getTests() {
  const testsResponse = await api.loadTests();
  testsResponse.forEach((test: ITest) => {
    tests.value.push({ label: test.name, value: test.id });
  });
}

onMounted(async () => {
  await getTests();
});

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(
          'base-btn' +
          (currentTab.value === 'users-table-tab' ? ' base-btn-yellow' : '')
        ),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(mainStore).changeTab('users-table-tab')))
        }, " Пользователи", 2),
        _createElementVNode("button", {
          class: _normalizeClass(
          'base-btn' + (currentTab.value === 'testsets-tab' ? ' base-btn-yellow' : '')
        ),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(mainStore).changeTab('testsets-tab')))
        }, " Тестсеты", 2),
        _createElementVNode("button", {
          class: _normalizeClass(
          'base-btn' +
          (currentTab.value === 'statistics-tab' ? ' base-btn-yellow' : '')
        ),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(mainStore).changeTab('statistics-tab')))
        }, " Статистика ", 2)
      ]),
      (currentTab.value === 'users-table-tab')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (openAssignTestPopup())),
            disabled: _unref(isSelectedUsers),
            class: "admin-panel__test-btn base-btn base-btn-yellow"
          }, " Назначить тест ", 8, _hoisted_3))
        : _createCommentVNode("", true),
      (currentTab.value === 'testsets-tab')
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (testsetsTabComponent.value.openTestCreate())),
            class: "admin-panel__test-btn base-btn base-btn-yellow"
          }, " Создать тест "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (currentTab.value === 'users-table-tab')
        ? (_openBlock(), _createBlock(UsersTableTab, {
            key: 0,
            users: _ctx.users,
            ref_key: "usersTableTabComponent",
            ref: usersTableTabComponent
          }, null, 8, ["users"]))
        : (currentTab.value === 'testsets-tab')
          ? (_openBlock(), _createBlock(TestsetsTab, {
              key: 1,
              ref_key: "testsetsTabComponent",
              ref: testsetsTabComponent
            }, null, 512))
          : (_openBlock(), _createBlock(StatisticsTab, {
              key: 2,
              ref_key: "statisticsTabComponent",
              ref: statisticsTabComponent
            }, null, 512)),
      _createVNode(_component_q_dialog, {
        class: "dialog-with-checkbox",
        modelValue: testDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((testDialog).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createVNode(_component_q_space),
                  _withDirectives(_createVNode(_component_q_btn, {
                    icon: "close",
                    flat: "",
                    round: "",
                    dense: ""
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_option_group, {
                    modelValue: selectedTests.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedTests).value = $event)),
                    options: tests.value,
                    type: "checkbox"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    disabled: selectedTests.value.length === 0,
                    class: "base-btn base-btn-yellow assigned-btn",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (assignTestForUser()))
                  }, " Назначить тест ", 8, _hoisted_6)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})